export class ContactRole {
    id: number = -1;
    name: string = '';
    createdAt: string = '';
    updatedAt: string = '';
}